/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountDetailsDto } from '../models/AccountDetailsDto';
import type { ChangePasswordDto } from '../models/ChangePasswordDto';
import type { EntityModelResponseContainerAccountDetailsDto } from '../models/EntityModelResponseContainerAccountDetailsDto';
import type { EntityModelResponseContainerAdminUserDto } from '../models/EntityModelResponseContainerAdminUserDto';
import type { TestVerificationCodeRequestDto } from '../models/TestVerificationCodeRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserRegistrationControllerService {
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static qrcodegen(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/qr',
        });
    }
    /**
     * @returns EntityModelResponseContainerAccountDetailsDto OK
     * @throws ApiError
     */
    public static getRegAccountDetails(): CancelablePromise<EntityModelResponseContainerAccountDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/registration/account_details',
        });
    }
    /**
     * @returns EntityModelResponseContainerAdminUserDto OK
     * @throws ApiError
     */
    public static changeAccountDetails({
        requestBody,
    }: {
        requestBody: AccountDetailsDto,
    }): CancelablePromise<EntityModelResponseContainerAdminUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/registration/account_details',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static rejectTermsAndConditions(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/registration/ack_tac',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static ackTermsAndConditions(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/registration/ack_tac',
        });
    }
    /**
     * @returns EntityModelResponseContainerAdminUserDto OK
     * @throws ApiError
     */
    public static changePassword({
        requestBody,
    }: {
        requestBody: ChangePasswordDto,
    }): CancelablePromise<EntityModelResponseContainerAdminUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/registration/change_pw',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerAdminUserDto OK
     * @throws ApiError
     */
    public static commitTfa({
        requestBody,
    }: {
        requestBody: TestVerificationCodeRequestDto,
    }): CancelablePromise<EntityModelResponseContainerAdminUserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/registration/commit_tfa',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static completeRegistration(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/registration/complete',
        });
    }
}
